/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
import {
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  Stack,
  useColorMode,
  Box,
} from '@chakra-ui/react';
import { useState } from 'react';
import { QRCode } from 'react-qrcode-logo';

export default function QRCodeModal({ url, isOpen, onClose }) {
  const [copied, setCopied] = useState();
  const handleCopy = () => {
    navigator.clipboard.writeText(url);
    setCopied('copied!');
    setTimeout(() => setCopied(null), 1000);
  };

  const handleClose = () => {
    setCopied(null);
    onClose && onClose();
  };

  return (
    <Modal size={'xl'} isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <Stack>
            <Center>
              <QRCode
                value={url}
                ecLevel={'H'}
                logoWidth={50}
                logoImage={
                  'https://cdn.jsdelivr.net/gh/CleverChuk/qdot@main/assets/logo.png'
                }
              />
            </Center>
            <div className="container">
              <div className='row'>
                <div className="col-sm-12 col-md-10 col-lg-10">
                  <Text>{url}</Text>
                </div>
                <div className="col-sm-12 col-md-2 col-lg-2">
                  <Box>
                    {copied ? (
                      <Text p={3}>{copied}</Text>
                    ) : (
                      <Button onClick={handleCopy} width={50} height={50}>
                        <span class="material-icons">content_copy</span>
                      </Button>
                    )}
                  </Box>
                </div>
              </div>
            </div>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
